/* eslint-disable */ !(function (t) {
  t.Redactor.prototype.fontfamily = function () {
    return {
      init: function () {
        var n = [
            'Arial',
            'Helvetica',
            'Georgia',
            'Times New Roman',
            'Monospace'
          ],
          o = this,
          e = {};
        t.each(n, function (t, n) {
          e['s' + t] = {
            title: n,
            func: function () {
              o.fontfamily.set(n);
            }
          };
        }),
          (e.remove = {
            title: 'Remove Font Family',
            func: o.fontfamily.reset
          });
        var i = this.button.add('fontfamily', this.lang.get('fontfamily'));
        this.button.addDropdown(i, e);
      },
      set: function (t) {
        this.inline.format('span', 'style', 'font-family:' + t + ';');
      },
      reset: function () {
        this.inline.removeStyleRule('font-family');
      }
    };
  };
})(jQuery);
